import React from 'react';
import { ArrowUpRight, Sparkles, Cloud, Cog } from 'lucide-react';

const pillars = [
  {
    icon: Sparkles,
    title: 'AI that works',
    desc: 'Turn data into decisions.'
  },
  {
    icon: Cloud,
    title: 'Cloud that scales',
    desc: 'Secure, elastic, ready for anything.'
  },
  {
    icon: Cog,
    title: 'Ops that hum',
    desc: '24×7 managed excellence.'
  }
];

const WhatWeDo = () => {
  return (
    <section id="about" className="relative py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="section-label mb-6">What We Do</div>

        <div className="grid md:grid-cols-[1.1fr_auto] gap-8 items-end mb-14">
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] text-white font-semibold tracking-tight max-w-3xl">
            <span className="gradient-text">Intelligent cloud.</span>
            <br />
            Real business impact.
          </h2>
          <a href="#contact" className="shrink-0">
            <button className="btn-gradient inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium whitespace-nowrap">
              Let&apos;s work together
              <ArrowUpRight size={16} />
            </button>
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {pillars.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.title} className="card-dark rounded-2xl p-6 hover:border-amber-500/30 transition-colors group">
                <div className="flex items-center gap-4">
                  <div className="h-12 w-12 rounded-2xl bg-amber-500/10 border border-amber-500/25 flex items-center justify-center shrink-0 group-hover:bg-amber-500/15 transition-colors">
                    <Icon size={22} className="text-amber-400" strokeWidth={1.5} />
                  </div>
                  <div>
                    <div className="text-white text-lg font-semibold leading-tight">{p.title}</div>
                    <div className="text-slate-400 text-sm mt-1">{p.desc}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
